namespace RioERP.Shipping {
    export interface ShippingRulesForm {
        ShippingProviderId: Serenity.IntegerEditor;
        EPriority: Serenity.EnumEditor;
        EPaymentMode: Serenity.EnumEditor;
    }

    export class ShippingRulesForm extends Serenity.PrefixedContext {
        static formKey = 'Shipping.ShippingRules';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ShippingRulesForm.init)  {
                ShippingRulesForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.EnumEditor;

                Q.initFormType(ShippingRulesForm, [
                    'ShippingProviderId', w0,
                    'EPriority', w1,
                    'EPaymentMode', w1
                ]);
            }
        }
    }
}
